import Layout from '@layout/Index'

export const home = [
  {
    path: '/',
    component: Layout,
    children: [
      {path: '', component: () => import(/* webpackChunkName: "home-index" */ './pages/HomeIndex.vue'), name: '首页'},
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/home/home.route.js